import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Box, Button, Icon, SpinnerLoader, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { checkAccessPage, EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { useInboxesViewContext } from 'pages/settings/pages/inboxes/context/inboxesViewContext'
import { InboxesTab } from 'pages/settings/pages/inboxes/pages/inboxesView/ui/InboxesTable/AllInboxesTab/InboxesTab'
import { InboxesPath } from 'pages/settings/pages/inboxes/route/inboxesPath'
import styles from './styles.module.scss'

export const InboxesView = observer(() => {
  const { inboxesViewStore, isManageOrganizationInboxes, manageInboxWrapper, init } =
    useInboxesViewContext()
  const { firstLoading, entities, items, showAccessModal } = inboxesViewStore
  const isTwilioNumberVendor = entities.organizationStore.isTwilioNumberVendor

  useEffect(() => {
    if (items.length && !isManageOrganizationInboxes) {
      showAccessModal()
    }
  }, [items.length, isManageOrganizationInboxes])

  useEffect(() => {
    void init()
  }, [])

  if (firstLoading) {
    return <SpinnerLoader ariaLabel={'InboxesView'} />
  }

  const addInbox = () =>
    manageInboxWrapper(() =>
      uiStore.changeRouteViaVue({ path: `/${InboxesPath.addInbox.stepsRoot}` })
    )

  if (!items.length && isTwilioNumberVendor) {
    return (
      <Box
        display='flex'
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        height='100%'
        gap={2}
      >
        <Icon color='var(--content-primary-tertiary)' icon='inboxes2' />
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
          justifyContent='center'
          gap={0.5}
        >
          <Typography variant='body-rg-medium' ariaLabel='NoAccessTitle'>
            Let’s create your first inbox
          </Typography>
          <div className={styles.createInboxText}>
            <Typography variant='body-md-regular' ariaLabel='NoAccessText' color='tertiary'>
              To start texting with your Twilio number, <br /> you’ll need to create an inbox.
            </Typography>
          </div>
        </Box>
        <Button text='Create inbox' iconProps={{ icon: 'add' }} size='medium' onClick={addInbox} />
      </Box>
    )
  }

  if (!items.length) {
    return (
      <Box
        display='flex'
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        height='100%'
        gap={2}
      >
        <Icon color='var(--content-primary-tertiary)' icon='inboxes2' />
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
          justifyContent='center'
          gap={0.5}
        >
          <Typography variant='body-rg-medium' ariaLabel='NoAccessTitle'>
            You don’t have access to any inboxes
          </Typography>
          <Typography variant='body-md-regular' ariaLabel='NoAccessText' color='tertiary'>
            Only inbox owners can view or manage them.
          </Typography>
        </Box>
      </Box>
    )
  }

  return (
    <div className={styles.content}>
      <Box
        display='flex'
        justifyContent='space-between'
        alignItems='flex-end'
        padding='64px 20px 0'
      >
        <div className={styles.inboxesDetailsHeader}>
          <Typography variant='heading-lg' ariaLabel='Inboxes_title'>
            Inboxes
          </Typography>
          <Typography variant='body-md-regular' ariaLabel='Numbers_subtitle_text' color='tertiary'>
            Manage all inboxes in your workspace
          </Typography>
        </div>
        {checkAccessPage(EnumAccessPageKeys.create_inbox, entities) && (
          <Button text='New inbox' iconProps={{ icon: 'add' }} size='medium' onClick={addInbox} />
        )}
      </Box>
      <div className={styles.table}>
        <InboxesTab />
      </div>
    </div>
  )
})
